import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Message from '../Message/Message';
import styles from './Messages.module.css';

export const Messages = ({ messages = [], speedSlow }) => {
  return (
    <div className={styles.wrapper}>
      {messages.length > 0 && (
        <TransitionGroup className={styles.wrapperMessages} appear={true}>
          {messages.length > 0 &&
            messages.map((item, i) => (
              <CSSTransition
                key={item.UUID}
                timeout={speedSlow}
                classNames="position">
                <Message
                  message={item.message}
                  rotateSign={item.rotateSign}
                  key={item.id}
                  isVertical={item.isVertical}
                />
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </div>
  );
};
